<template>
  <transition name="dwp--fade">
    <i-frame id="dwp--wrapper" v-if="open">
      <UpdateMessage />
    </i-frame>
  </transition>
</template>

<script>
import store from "@/store";
import Modal from "@/components/ui/Modal.vue";
import Logo from "@/components/illustrations/Logo.vue";
import { sync, call } from "vuex-pathify";

export default {
  store,
  components: {
    Modal,
    Logo
  },
  computed: {
    open: sync("ui/open")
  },
  components: {
    UpdateMessage: () => import("@/components/UpdateMessage.vue"),
    iFrame: () => import("@/components/ui/iFrame.vue")
  }
};
</script>